import moment from 'moment';
import { storageService } from '../services/StorageService';

const eventService: any = {
  _actionDuration: {},

  startActionDuration(key: string) {
    if (key) {
      this._actionDuration[key] = moment.now();
      storageService.set('actionDuration', this._actionDuration);
    }
  },

  init() {
    storageService.get('actionDuration').then((value: any) => {
      if (value) {
        this._actionDuration = value;
      }
    });
  },

  endActionDuration(key: string): any {
    if (key) {
      const durationInMs = moment(moment.now()).diff(this._actionDuration[key]);
      const durationInSec = Math.floor(moment.duration(durationInMs).asSeconds());
      return durationInSec;
    }
    return 0;
  },
};

eventService.init();
export default eventService;